class ShippingBarV2 extends HTMLElement {
  constructor() {
    super();
    this.initShippingBar();
  }

  initShippingBar() {
    const cartDrawer = document.querySelector("cart-drawer");
    const mergeList = document.querySelector('[data-merge-list="cart-items"]');
    const cartEvent = new Event("cartOpenOrQuantityChange");

    // Watch drawer open or class toggle
    const drawerObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        const isClassChange = mutation.attributeName === "class";
        const isOpenAttrChange = mutation.attributeName === "open";
        if (isClassChange || isOpenAttrChange) {
          const isOpen = cartDrawer.hasAttribute("open");
          if (isOpen) cartDrawer.dispatchEvent(cartEvent);
        }
      }
    });

    drawerObserver.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ["class", "open"],
    });

    // Watch quantity updates (merge-item-refreshing class removed)
    if (mergeList) {
      const itemElements = mergeList.querySelectorAll("[data-merge-list-item]");
      itemElements.forEach((item) => {
        new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (
              mutation.type === "attributes" &&
              mutation.attributeName === "class" &&
              !item.classList.contains("merge-item-refreshing")
            ) {
              setTimeout(() => {
                cartDrawer.dispatchEvent(cartEvent);
              }, 300);
            }
          });
        }).observe(item, { attributes: true });
      });
    }

    // Update bar on event
    cartDrawer.addEventListener("cartOpenOrQuantityChange", () => {
      setTimeout(() => {
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            const subtotal = cart.total_price / 100;
            const bar = document.querySelector(".shipping-bar");
            if (!bar) return;

            const priceval1 = Number(bar.dataset.priceval1 || 0);
            const priceval2 = Number(bar.dataset.priceval2 || 0);
            const priceval3 = Number(bar.dataset.priceval3 || 0);
            const msg1 = bar.dataset.disccoupon1 || "";
            const msg2 = bar.dataset.disccoupon2 || "";
            const msg3 = bar.dataset.disccoupon3 || "";
            const finalMsg = bar.dataset.finalthresholdmessage || "";

            const messageEl = document.querySelector(".shipping-bar__message");
            const amtEl = document.querySelector(".discount-away-amt");
            const msgNextEl = document.querySelector(".discount-away-next-offer");
            const indicator = document.querySelector(".shipping-bar__indicator");
            const thresholdImages = document.querySelectorAll(".threshold-image");

            thresholdImages.forEach((img) => img.classList.remove("active"));
            indicator.className = "shipping-bar__indicator";

            // Reset content
            if (amtEl) amtEl.textContent = "";
            if (msgNextEl) msgNextEl.textContent = "";

            if (subtotal > 0 && subtotal < priceval1) {
              if (amtEl) amtEl.textContent = `₹${(priceval1 - subtotal).toFixed(2)}`;
              if (msgNextEl) msgNextEl.textContent = msg1;
              if (messageEl) messageEl.innerHTML = `
                <p>You are <strong class="discount-away-amt">₹${(priceval1 - subtotal).toFixed(2)}</strong> away from <strong class="discount-away-next-offer">${msg1}</strong></p>`;
              indicator.classList.add("step1");

            } else if (subtotal >= priceval1 && subtotal < priceval2) {
              if (amtEl) amtEl.textContent = `₹${(priceval2 - subtotal).toFixed(2)}`;
              if (msgNextEl) msgNextEl.textContent = msg2;
              if (messageEl) messageEl.innerHTML = `
                <p>You are <strong class="discount-away-amt">₹${(priceval2 - subtotal).toFixed(2)}</strong> away from <strong class="discount-away-next-offer">${msg2}</strong></p>`;
              indicator.classList.add("step3");
              thresholdImages[0]?.classList.add("active");

            } else if (subtotal === priceval2) {
              if (messageEl) messageEl.innerHTML = `<p>You unlocked ${msg2}</p>`;
              indicator.classList.add("step4");
              thresholdImages[0]?.classList.add("active");
              thresholdImages[1]?.classList.add("active");

            } else if (subtotal > priceval2 && subtotal < priceval3) {
              if (amtEl) amtEl.textContent = `₹${(priceval3 - subtotal).toFixed(2)}`;
              if (msgNextEl) msgNextEl.textContent = msg3;
              if (messageEl) messageEl.innerHTML = `
                <p>You are <strong class="discount-away-amt">₹${(priceval3 - subtotal).toFixed(2)}</strong> away from <strong class="discount-away-next-offer">${msg3}</strong></p>`;
              indicator.classList.add("step5");
              thresholdImages[0]?.classList.add("active");
              thresholdImages[1]?.classList.add("active");

            } else if (subtotal === priceval3) {
              if (messageEl) messageEl.innerHTML = `<p>You unlocked ${msg3}</p>`;
              indicator.classList.add("step6");
              thresholdImages[0]?.classList.add("active");
              thresholdImages[1]?.classList.add("active");
              thresholdImages[2]?.classList.add("active");

            } else if (subtotal > priceval3) {
              if (messageEl) messageEl.innerHTML = `<p>${finalMsg}</p>`;
              indicator.classList.add("step7");
              thresholdImages[0]?.classList.add("active");
              thresholdImages[1]?.classList.add("active");
              thresholdImages[2]?.classList.add("active");
            }
          });
      }, 300);
    });
  }
}

customElements.define("shipping-bar-v2", ShippingBarV2);
